// extracted by mini-css-extract-plugin
module.exports = {"Image":"Gallery_Image__lFCAA","Caption":"Gallery_Caption__3jf53"};